export default {"src":"/_next/static/media/WhatIsSignalist.9c73ea97.svg","height":527,"width":1007};